// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueTruncate from 'vue-truncate-filter';
import App from './App';

Vue.use(VueTruncate);
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
	el: '#app',
	components: { App },
	template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js